<template>
  <div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="全部" name="a" itemtype="" style="width: 100px">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge class="item">
              <span style="width: 100px">全部</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="待支付" name="b" itemtype="0">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status0" class="item">
              <span>待支付</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="待发货" name="c">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status1" class="item">
              <span>待发货</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="已发货" name="f">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status4" class="item">
              <span>已发货</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="已完成" name="g">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status8" class="item">
              <span>已完成</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="退款中" name="d">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status2" class="item">
              <span>退款中</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
      <el-tab-pane label="已退款" name="e">
        <template #label>
          <span class="custom-tabs-label">
            <el-badge :value="remindCount.status3" class="item">
              <span>已退款</span>
            </el-badge>
          </span>
        </template>
      </el-tab-pane>
    </el-tabs>
    <!-- 搜索部分 -->
    <div class="table-container">
      <vab-query-form style="margin: 0">
        <el-form ref="form" :model="queryForm" :inline="true" @submit.native.prevent>
          <el-form-item label="">
            <el-input v-model.trim="queryForm.user_code" placeholder="用户编号" clearable style="width: 150px"/>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="queryForm.batch_code" placeholder="批次编号" clearable style="width: 200px" />
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="queryForm.code" placeholder="订单编号" clearable style="width: 200px" />
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="queryForm.express_code" placeholder="运单编号" clearable style="width: 200px" />
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="queryForm.is_supplement" clearable placeholder="商品类型" @keyup.enter.native="handleQuery" style="width: 150px;">
              <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="queryForm.user_name" placeholder="收货人" clearable style="width: 150px" />
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="queryForm.goods_name" placeholder="商品名" clearable style="width: 200px" />
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="queryForm.barcode" placeholder="商品条形码" clearable style="width: 200px" />
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="queryForm.record" placeholder="商品备案码" clearable style="width: 200px" />
          </el-form-item>
          <!-- 时间 -->
          <el-form-item label="">
            <el-date-picker v-model="time" type="datetimerange" start-placeholder="开始时间" range-separator="-"
              value-format="yyyy-MM-dd HH:mm:ss" end-placeholder="结束时间" style="width: 360px"
              :default-time="['00:00:00', '23:59:59']" @change="getListData" />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" native-type="submit" @click="handleQuery">
              查询
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-download" type="primary" @click="export_excel">
              导出
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-delete" type="danger" @click="handleDelete">
              批量删除
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="batchOrderPull(4)">
              顺丰批量拉单
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="batchOrderPull(7)">
              中通批量拉单
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button :loading="SFHdoPreviewLoading" type="primary" @click="get_size(0, 'SFH')">
              打印面单
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form>

      <el-table ref="tableSort" v-loading="listLoading" :data="list" :element-loading-text="elementLoadingText"
        :height="height" style="width: 100%" border @selection-change="setSelectRows" @sort-change="tableSortChange">
        <el-table-column show-overflow-tooltip type="selection" width="55" align="center"></el-table-column>
        <!-- 用户ID -->
        <el-table-column show-overflow-tooltip prop="user_code" label="用户编号" width="100"></el-table-column>
        <!-- 商品图片 -->
        <!-- <el-table-column show-overflow-tooltip label="商品图片">
          <template #default="{ row }">
            <el-image :preview-src-list="imageList" :src="row.pic"></el-image>
          </template>
        </el-table-column> -->
        <!-- 商品规格 -->
        <el-table-column align="center" width="450" label="商品规格">
          <template #default="{ row }">
            <div>
              <!-- <span v-for="(item,index) in row.goods_order_spec">{{item.sku}}</span> -->
              <div class="sku_item" v-for="(item, index) in row.goods_order_spec" :key="index" style="">
                <img style="width: 60px;height: 60px;" :src="torul(item.pic ? item.pic : row.pic)" alt="" />
                <div style="display: flex; flex-direction: column;margin-left: 8px;align-items: flex-start;">
                  <span style="text-align: left;">名称:{{ item.goods_name }}</span>
                  <span>规格:{{ item.sku }}</span>
                  <span>数量:{{ item.num }}</span>
                  <span>价格:{{ item.price }}</span>
                  <span>条形码:{{ item.barcode }}</span>
                  <span>备案号:{{ item.record }}</span>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>

        <!-- 状态 -->
        <el-table-column label="状态" align="center">
          <template #default="{ row }">
            <el-tag v-if="row.status == 0" size="small" type="warning">待支付</el-tag>
            <el-tag v-if="row.status == 1" size="small" type="warning">待发货</el-tag>
            <el-tag v-if="row.status == 4" size="small" type="success">已发货</el-tag>
            <el-tag v-if="row.status == 2" size="small">退款中</el-tag>
            <el-tag v-if="row.status == 3" size="small" type="danger">已退款</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" width="550" label="订单信息/收货地址">
          <template #default="{ row }">
            <div style="display: flex; flex-direction: column;margin-left: 8px;align-items: flex-start;">
              <span>批次编号:{{ row.batch_code }}</span>
              <span>订单编号:{{ row.code }}</span>
              <div v-if="row.status == 1 && row.is_supplement == 0" class="express_code_css">
                运单编号:
                <input v-model="row.express_code" type="text" style="width: 190px; margin-right: 5px;"
                  placeholder="输入运单号,自动发货" />
                <button @click="yundanHao_change(row)">保存</button>
              </div>
              <div v-if="row.status == 4 && row.is_supplement == 0">运单编号:{{ row.express_code }}</div>
              <span>支付单号:{{ row.pay_code }}</span>
              <span>下单时间:{{ row.add_time }}</span>
              <span v-if="row.is_supplement == 0">收货人:{{ row.name }}</span>
              <span v-if="row.is_supplement == 0">地址:{{ row.province + row.city + row.area + row.address }}</span>
              <span v-if="row.is_supplement == 0">身份证:{{ row.idcode }}</span>
            </div>
          </template>
        </el-table-column>
        <!-- 订单金额 -->
        <el-table-column show-overflow-tooltip prop="price" width="210" label="订单金额">
          <template #default="{ row }">
            <div>订单数量:{{ row.num }}</div>
            <div>订单总金额:{{ row.total_price }}</div>
            <div v-if="row.price > 0">现金支付:{{ row.price }}</div>
            <div v-if="row.user_balance > 0">余额支付:{{ row.user_balance }}</div>
            <div v-if="row.status == 3 && row.pay_log.cash_price > 0" style="color: red;">现金退款:{{ row.pay_log.cash_price
            }}</div>
            <div v-if="row.status == 3 && row.pay_log.refund_balance > 0" style="color: red;">余额退款:{{
              row.pay_log.refund_balance }}</div>
            <div v-if="row.status == 3 || row.status == 2" style="color: red;">退款原因:{{
              row.order_apply_refund.apply_reason }}</div>
            <div v-if="row.status == 3" style="color: red;">退款时间:{{ row.order_apply_refund.add_time }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作面板" width="180px" fixed="right">
          <template #default="{ row }">
            <div style="display: flex;flex-direction: column;">
              <el-button v-if="row.is_supplement == 0 && row.status == 0 && row.status == 1" type="text" size="mini"
                @click="handleEdit(row)">修改地址</el-button>
              <!-- <el-button v-if="row.status == 3" style="margin-left: 0;" type="text" size="mini"
                @click="handledetails(row)">
                详情
              </el-button> -->
              <el-button style="margin-left: 0;" v-if="row.status == 1" type="text" size="mini" @click="fahuo(row)">
                发货
              </el-button>
              <el-button style="color: red;margin-left: 0;" v-if="row.status == 0" type="text" size="mini"
                @click="colos_order(row)">
                关闭订单
              </el-button>
              <el-button v-if="row.status == 0" style="color: red;margin-left: 0;" type="text" size="mini"
                @click="handleDelete(row)">
                删除
              </el-button>
              <el-button style="color: orange;margin-left: 0;" v-if="row.status == 2" type="text" size="mini"
                @click="refund(row)">
                退款
              </el-button>
              <el-button style="color: orange;margin-left: 0;" v-if="row.status == 1" type="text" size="mini"
                @click="voluntaryRefund(row)">
                主动退款
              </el-button>
              <el-button style="margin-left: 0;" v-if="row.status == 4" type="text" size="mini"
                @click="signCompleted(row)">
                签收完成
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :background="background" :current-page="queryForm.page" :layout="layout"
        :page-sizes="[20, 40, 60, 100]" :page-size="queryForm.limit" :total="total"
        @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>
      <commodity-list ref="edit" @fetch-data="getnewlist"></commodity-list>
      <tui-kuan ref="tuikuan" @change="getnewlist"></tui-kuan>
      ‌<VoluntaryRefund ref="voluntaryRefund" @change="getnewlist"></VoluntaryRefund>
      ‌<modifyAddress ref="modifyAddress" @change="getnewlist"></modifyAddress>
      <el-dialog title="面单尺寸" :visible.sync="mianDan_chiCun_show">
        <el-form>
          <el-form-item label="面单尺寸" :label-width="formLabelWidth">
            <el-select v-model="mianDan_chiCun_num" placeholder="请选择面单尺寸">
              <el-option label="100*150" :value="1"></el-option>
              <el-option label="100*180" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="mianDan_chiCun_show = false">取 消</el-button>
          <el-button type="primary" @click="shure_size">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  goodsOrderDel,
  goodsOrderList,
  orderRefundRefund,
  deliver_goods,
  GoodsOrder_excel_out,
  goodsOrderStatus,
  Index_country_list,
  GoodsOrder_cancelOrder,
  goods_order_api,
  print_detail,
  express_update,
  confirm_receipt
} from '@/api/xgcApi'
import {
  baseURL_print,
  getUploadUrl
} from '@/config'
import commodityList from '../components/commodityList.vue'
import modifyAddress from '../components/modifyAddress.vue'
import tuiKuan from '../components/tuikuanGoods.vue'
import VoluntaryRefund from '../components/‌goodsVoluntaryRefund.vue'
export default {
  name: 'manageCommodityList',
  components: {
    commodityList,
    tuiKuan,
    VoluntaryRefund,
    modifyAddress
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger',
      }
      return statusMap[status]
    },
  },
  data() {
    return {
      formLabelWidth: '100px',
      height: '70vh',

      xin_list: [],
      list: [],
      imageList: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      background: true,
      selectRows: '',
      elementLoadingText: '正在加载...',
      queryForm: {
        page: 1,
        limit: 20,
        status: '',
        gtype: '2',
        kor_type: 0,
        start_time: '',
        end_time: '',
        user_code: '',
        is_supplement: '0',
        record: '',
        barcode: '',
        goods_name: '',
        batch_code:''
      },
      value1: '',
      value: '',
      activeName: 'a',
      remindCount: {},
      isShowCode: false,
      options1: [{
        value: '0',
        label: '普通商品',
      },
      {
        value: '1',
        label: '补价商品 ',
      },
      ],
      yt_type: null,
      name_type: null,
      mianDan_chiCun_show: false, //选择面单尺寸
      mianDan_chiCun_num: 1, //打印的面单的尺寸
      SFHdoPreviewLoading: false, //顺丰打印预览loading
      time: '',
      socket: null, //打印相关
      doPrintLoading: false, //打印面单loading
      doPreviewLoading: false, //打印预览loading
      SFdoPreviewLoading: false, //顺丰打印预览loading
      printTaskId: 0, //打印相关
      printers: null, //打印相关
      defaultPrinter: null, //打印相关
      waybillNO: '0000000000000', //打印相关
      waybillTemplateURL: baseURL_print + 'admin/index/print', //打印请求路径
    }
  },
  // computed: {
  //   height() {
  //     return this.$baseTableHeight()
  //   },
  // },
  created() {
    this.fetchData()
  },
  mounted() {
    this.getXian()
    this.doConnect()
  },
  methods: {
    yundanHao_change(row) {
      var data = {
        id: row.id,
        express_code: row.express_code,
      }
      express_update(data).then((res) => {
        this.$baseMessage('修改成功', 'success')
        this.handleQuery()
      })
    },
    // 选择时间，提取开始时间，结束时间
    getListData() {
      if (this.time == null) {
        this.queryForm.start_time = '';
        this.queryForm.end_time = '';
      } else {
        this.queryForm.start_time = this.time[0];
        this.queryForm.end_time = this.time[1];
      }
    },
    // 圆通打印/预览 选择尺寸弹出层
    get_size(type, name) {
      // type 0打印 1预览
      this.yt_type = type
      this.name_type = name
      this.mianDan_chiCun_show = true
    },
    shure_size() {
      // 确认面单打印尺寸
      if (this.name_type == 'SFH') {
        if (this.yt_type == 0) {
          // 0打印
          this.doPrint('SFH')
        } else {
          // 预览
          this.doPreview('SFH')
        }
      }

      this.mianDan_chiCun_show = false
    },

    // 打印预览
    doPreview(type) {
      if (this.selectRows.length > 0) {
        if (type == 'YT') {
          var ids = []
          this.selectRows.forEach((item) => {
            if (item.pulling_type == 1) {
              ids.push(item.id)
            }
          })
          this.$baseConfirm('你确定打印预览选中项吗', null, async () => {
            var data = {
              id: ids,
              type: this.mianDan_chiCun_num,
            }
            Order_printCheck(data).then((res) => {
              var printData = this.getPrintData()
              printData.task.preview = true
              this.doPreviewLoading = true

              this.socket.send(JSON.stringify(printData))
            })
          })
        }
        if (type == 'SFK') {
          // 顺丰空运面单打印
          var ids = []
          this.selectRows.forEach((item) => {
            if (item.pulling_type == 3) {
              ids.push(item.id)
            }
          })
          var data = {
            id: ids,
          }
          var urls = ''
          if (this.mianDan_chiCun_num == 1) {
            // 150尺寸 顺丰空运面单
            console.log('150尺寸 顺丰海运面单')
            urls = 'https://cloudprint.cainiao.com/template/standard/877837'
          } else {
            // 180尺寸 顺丰空运面单
            console.log('180尺寸 顺丰海运面单')
            urls =
              'https://cloudprint.cainiao.com/template/standard/771230/16'
          }
          // 验证接口
          Order_printCheck(data).then((res) => {
            var arrs = []
            var from = {}
            from = res.data.from
            res.data.list.forEach((item, index) => {
              const goodsInfo = item.brand.map(item => `${item.brand_type_name} * ${item.num}`).join(',');
              var dataArr = {
                documentID: this.waybillNO,
                contents: [
                  {
                    // templateURL: 'https://cloudprint.cainiao.com/template/standard/771230/16',
                    templateURL: urls,
                    signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
                    data: {
                      orderNo: item.code, //订单号
                      logisticsNo: item.express_code, //运单号
                      shortAddress: item.pulling.mark, // 三段码
                      packageCenterName: item.packageCenterName, //
                      consignee: item.name, //收件人
                      consigneeTel: item.phone, //收件人联系方式
                      consigneeAddr: `${item.province_name} ${item.city_name} ${item.area_name} ${item.address}`, //收件人地址
                      consigner: from.username, //发件人
                      consignerTel: from.mobile, //发件人电话
                      consignerAddr: `${from.province} ${from.city} ${from.area} ${from.address}`, //发件人地址
                      goodsInfo: goodsInfo, //物品名
                      note: item.remark2, //备注
                      logisticsMark: '', // 没用
                      twoDimensionCode: item.pulling.two_dimension_code, //二维码
                      now: item.add_time, //时间
                    },
                  },
                ],
              }
              arrs.push(dataArr)
            })
            var printData = this.SFgetPrintData(arrs)
            printData.task.preview = true
            this.SFKdoPreviewLoading = true
            this.socket.send(JSON.stringify(printData))
          })
        }
        if (type == 'SFH') {
          // 顺丰海运面单打印
          var ids = []
          this.selectRows.forEach((item) => {
            // if (item.pulling_type == 4) {
            ids.push(item.id)
            // }
          })
          var data = {
            id: ids,
          }
          var urls = ''
          if (this.mianDan_chiCun_num == 1) {
            // 150尺寸 顺丰海运面单
            console.log('预览 150尺寸 顺丰海运面单')
            urls = 'https://cloudprint.cainiao.com/template/standard/877264'
          } else {
            // 180尺寸 顺丰海运面单
            console.log('预览 180尺寸 顺丰海运面单')
            urls = 'https://cloudprint.cainiao.com/template/standard/765571'
          }

          // 验证接口
          Order_printCheck(data).then((res) => {
            var arrs = []
            var from = {}
            from = res.data.from
            res.data.list.forEach((item, index) => {
              const goodsInfo = item.brand.map(item => `${item.brand_type_name} * ${item.num}`).join(',');
              var dataArr = {
                documentID: this.waybillNO,
                contents: [
                  {
                    templateURL: urls,
                    signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
                    data: {
                      orderNo: item.code, //订单号
                      logisticsNo: item.express_code, //运单号
                      shortAddress: item.pulling.mark, // 三段码
                      packageCenterName: item.packageCenterName, //
                      consignee: item.name, //收件人
                      consigneeTel: item.phone, //收件人联系方式
                      consigneeAddr: `${item.province_name} ${item.city_name} ${item.area_name} ${item.address}`, //收件人地址
                      consigner: from.username, //发件人
                      consignerTel: from.mobile, //发件人电话
                      consignerAddr: `${from.province} ${from.city} ${from.area} ${from.address}`, //发件人地址
                      goodsInfo: goodsInfo, //物品名`备注:${item.remark2}`, //备注 
                      note: item.remark2, //物品名
                      logisticsMark: '', // 没用
                      twoDimensionCode: item.pulling.two_dimension_code, //二维码
                      now: item.add_time, //时间
                    },
                  },
                ],
              }
              arrs.push(dataArr)
            })
            var printData = this.SFgetPrintData(arrs)
            printData.task.preview = true
            this.SFHdoPreviewLoading = true
            this.socket.send(JSON.stringify(printData))
          })
        }
      } else {
        this.$baseMessage('未选中任何行', 'warning')
        return false
      }
    },

    // 点击修改地址
    handleEdit(row) {
      this.$refs['modifyAddress'].showEdit(row)
    },

    // 关闭订单
    colos_order(row) {
      var data = {
        "id": row.id
      }
      // this.listLoading = true
      this.$confirm('确认手动关闭此订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then((success) => {
        GoodsOrder_cancelOrder(data).then(res => {
          this.$message({
            type: 'success',
            message: '关闭成功'
          })
          // this.listLoading = false
          this.fetchData()
        }).catch(err => {
          // this.listLoading = false
        })
      })
        .catch(() => {
          // this.listLoading = false
          this.$message({
            type: 'info',
            message: '取消操作',
          })
        })
    },
    getXian() {
      Index_country_list({}).then(res => {
        this.xin_list = res.data
      })
    },
    torul(url) {
      // 使用可选链和空值合并运算符
      var arr = url?.split(",") ?? [];
      return arr[0] || '';
    },
    // 批量导出
    export_excel() {
      if (this.selectRows.length > 0) {
        const ids = this.selectRows.map((item) => item.id).join()
        var data = {
          id: ids
        }
        GoodsOrder_excel_out(data).then(res => {
          this.$message({
            type: 'success',
            message: '导出成功'
          })
          const fileUrl = getUploadUrl + res.data
          window.location.href = fileUrl
        })
      } else {
        GoodsOrder_excel_out(this.queryForm).then(res => {
          console.log(res)
          this.$message({
            type: 'success',
            message: '条件导出成功',
          })
          const fileUrl = getUploadUrl + res.data
          window.open(fileUrl)
        })
      }
    },
    fahuo(row) {
      this.$confirm('确认继续发货?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then((success) => {
          var data = {
            "order_id": row.id,
            "status": 4 //0待支付 1已支付 2退款中 3已退款 4已发货
          }
          goodsOrderStatus(data).then((res) => {
            this.$message({
              type: 'success',
              message: '发货成功!',
            })
            this.getnewlist()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消发货',
          })
        })
    },
    signCompleted(row) {
      this.$confirm('确认签收完成?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then((success) => {
          var data = {
            id: row.id,
          }
          confirm_receipt(data).then((res) => {
            this.$message({
              type: 'success',
              message: '签收成功!',
            })
            this.getnewlist()
          })
        })
        .catch((err) => {
        })
    },
    // table，切换方法
    handleClick(tab, event) {
      switch (tab.name) {
        case 'a':
          this.queryForm.status = ''
          break
        case 'b':
          this.queryForm.status = 0
          break
        case 'c':
          this.queryForm.status = 1
          break
        case 'd':
          this.queryForm.status = 2
          break
        case 'e':
          this.queryForm.status = 3
          break
        case 'f':
          this.queryForm.status = 4
          break
        case 'g':
          this.queryForm.status = 8
          break
      }
      this.queryForm.page = 1
      this.fetchData()
    },
    getnewlist() {
      this.fetchData()
    },
    // 查看列表图片
    tableSortChange() {
      const imageList = []
      this.$refs.tableSort.tableData.forEach((item, index) => {
        imageList.push(item.img)
      })
      this.imageList = imageList
    },
    // 多选
    setSelectRows(val) {
      this.selectRows = val
      this.chooseItem = val
    },
    // 点击详情
    handledetails(row) {
      this.$refs['edit'].showEdit(row)
    },
    // 主动退款
    voluntaryRefund(row) {
      var type = row.gtype == 1 ? 2 : 5
      this.$refs['voluntaryRefund'].open(row, type)
    },
    // 点击退款
    refund(row) {
      var type = row.gtype == 1 ? 2 : 5
      this.$refs['tuikuan'].open(row, type)
    },
    // 删除
    handleDelete(row) {
      if (row.id) {
        this.$baseConfirm('你确定要删除当前项吗', null, async () => {
          const {
            msg
          } = await goodsOrderDel({
            id: row.id,
          })
          this.$baseMessage(msg, 'success')
          this.fetchData()
        })
      } else {
        if (this.selectRows.length > 0) {
          const ids = this.selectRows.map((item) => item.id).join()
          this.$baseConfirm('你确定要删除选中项吗', null, async () => {
            const {
              msg
            } = await goodsOrderDel({
              id: ids,
            })
            this.$baseMessage(msg, 'success')
            this.fetchData()
          })
        } else {
          this.$baseMessage('未选中任何行', 'warning')
          return false
        }
      }
    },
    // 批量拉单
    batchOrderPull(type) {
      if (this.selectRows.length > 0) {
        const ids = this.selectRows.map((item) => item.id).join()
        this.$baseConfirm('确定进行拉单操作？', null, async () => {
          const {
            msg
          } = await goods_order_api({
            id: ids,
            type: type
          })
          this.$baseMessage(msg, 'success')
          this.fetchData()
        })
      } else {
        this.$baseMessage('未选中任何行', 'warning')
        return false
      }
    },
    doConnect() {
      var that = this
      this.socket = new WebSocket('ws://127.0.0.1:13528')
      var result = '打印成功'
      var tmptaskID = '0'
      var that = this
      // 打开Socket
      that.socket.onopen = function (event) {
        // 监听消息
        that.socket.onmessage = function (event) {
          var data = JSON.parse(event.data)
          that.printers = data.printers
          that.defaultPrinter = data.defaultPrinter
          if (data.cmd == 'notifyPrintResult') {
            // 打印出现问题
            var result = '打印成功'
            if (data.taskID != tmptaskID) {
              for (var i = 0; i < data.printStatus.length; i++) {
                if (data.printStatus[i].status == 'failed') {
                  result = '打印失败'
                  that.$message({
                    type: 'error',
                    message: '打印失败',
                  })
                  break
                } else if (data.printStatus[i].status == 'canceled') {
                  that.$message({
                    type: 'error',
                    message: '取消打印任务',
                  })
                  result = '取消打印任务'
                  break
                }
              }
              tmptaskID = data.taskID
            }
            that.doPreviewLoading = false
            that.doPrintLoading = false
            that.SFdoPreviewLoading = false
            that.SFHdoPreviewLoading = false
          } else if (data.cmd == 'print') {
            // 这里面写打印/预览成功之后的回调
            that.doPreviewLoading = false
            that.doPrintLoading = false
            that.SFdoPreviewLoading = false
            that.SFHdoPreviewLoading = false
            if (data.previewURL) {
              // 预览成功打开pdf文件url
              window.open(data.previewURL)
            } else {
              // 打印成功
              // var date =this.chooseItem
              var ids = []
              that.chooseItem.forEach((item, index) => {
                ids.push(item.id)
              })
              var date = {
                id: ids.join(','),
              }
              if (data.status != 'success') {
                that.$message({
                  type: 'error',
                  message: data.msg,
                })
              } else {
                Order_printStatus(date).then((res) => {
                  // 这个是打印成功回调
                  that.$message({
                    type: 'success',
                    message: '打印成功',
                  })
                })
              }
            }
          }
        }
        // 监听Socket的关闭
        that.socket.onclose = function (event) {
          that.$message({
            type: 'error',
            message: '打印机失去联系，请刷新网页重新连接',
          })
        }
      }
      that.socket.onerror = function (event) {
        that.$message({
          type: 'error',
          message: '打印机出现问题,请联系客服',
        })
      }
    },
    //打印电子面单
    doPrint(type) {
      if (this.selectRows.length > 0) {
        // const ids = this.selectRows.map((item) => item.id).join()
        // this.$baseConfirm('你确定打印选中项吗', null, async () => {
        //   var data = {
        //     id: ids,
        //   }
        //   Order_printCheck(data).then((res) => {
        //     var printData = this.getPrintData()
        //     this.doPrintLoading = true
        //     this.socket.send(JSON.stringify(printData))
        //   })
        // })
        if (type == 'YT') {
          // 圓通面單打印
          // var ids = this.selectRows.map((item) => item.id).join(',')
          var ids = []
          this.selectRows.forEach((item) => {
            if (item.pulling_type == 1) {
              ids.push(item.id)
            }
          })
          this.$baseConfirm('你确定打印预览选中项吗', null, async () => {
            var data = {
              id: ids,
              type: this.mianDan_chiCun_num,
            }
            Order_printCheck(data).then((res) => {
              var printData = this.getPrintData()
              this.doPreviewLoading = true
              this.socket.send(JSON.stringify(printData))
            })
          })
        }
        if (type == 'SFK') {
          // 顺丰空运面单打印
          var ids = []
          this.selectRows.forEach((item) => {
            if (item.pulling_type == 3) {
              ids.push(item.id)
            }
          })
          var data = {
            id: ids,
          }
          var urls = ''
          if (this.mianDan_chiCun_num == 1) {
            // 150尺寸 顺丰空运面单
            console.log('150尺寸 顺丰空运面单')
            urls = 'https://cloudprint.cainiao.com/template/standard/877837'
          } else {
            // 180尺寸 顺丰空运面单
            console.log('180尺寸 顺丰空运面单')
            urls =
              'https://cloudprint.cainiao.com/template/standard/771230/16'
          }
          // 验证接口
          Order_printCheck(data).then((res) => {
            var arrs = []
            var from = {}
            from = res.data.from
            res.data.list.forEach((item, index) => {
              const goodsInfo = item.brand.map(item => `${item.brand_type_name} * ${item.num}`).join(',');
              var dataArr = {
                documentID: this.waybillNO,
                contents: [
                  {
                    // templateURL: 'https://cloudprint.cainiao.com/template/standard/771230/16',
                    templateURL: urls,
                    signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
                    data: {
                      orderNo: item.code, //订单号
                      logisticsNo: item.express_code, //运单号
                      shortAddress: item.pulling.mark, // 三段码
                      packageCenterName: item.packageCenterName, //
                      consignee: item.name, //收件人
                      consigneeTel: item.phone, //收件人联系方式
                      consigneeAddr: `${item.province_name} ${item.city_name} ${item.area_name} ${item.address}`, //收件人地址
                      consigner: from.username, //发件人
                      consignerTel: from.mobile, //发件人电话
                      consignerAddr: `${from.province} ${from.city} ${from.area} ${from.address}`, //发件人地址
                      goodsInfo: goodsInfo, //物品名
                      note: item.remark2, //备注
                      logisticsMark: '', // 没用
                      twoDimensionCode: item.pulling.two_dimension_code, //二维码
                      now: item.add_time, //时间
                    },
                  },
                ],
              }
              arrs.push(dataArr)
            })
            var printData = this.SFgetPrintData(arrs)
            this.SFKdoPreviewLoading = true
            this.socket.send(JSON.stringify(printData))
          })
        }
        if (type == 'SFH') {
          // 顺丰海运面单打印
          var ids = []
          this.selectRows.forEach((item) => {
            // if (item.pulling_type == 4) {
            ids.push(item.id)
            // }
          })
          var data = {
            goods_order_id: ids,
          }
          var urls = ''
          if (this.mianDan_chiCun_num == 1) {
            // 150尺寸 顺丰海运面单
            console.log('150尺寸 顺丰海运面单')
            urls = 'https://cloudprint.cainiao.com/template/standard/877264'
          } else {
            // 180尺寸 顺丰海运面单
            console.log('180尺寸 顺丰海运面单')
            urls = 'https://cloudprint.cainiao.com/template/standard/765571'
          }
          // 验证接口
          print_detail(data).then((res) => {
            var arrs = []
            var from = {}
            from = res.data.from
            res.data.list.forEach((item, index) => {
              let result = ''
              if (item.goods_order_spec && item.goods_order_spec.length > 0) {
                // 合并相同名称
                const merged = item.goods_order_spec.reduce((acc, t) => {
                  const key = t.sku;
                  acc[key] = (acc[key] || 0) + t.num;
                  return acc;
                }, {});
                // 直接拼接成字符串
                result = Object.entries(merged)
                  .map(([name, num]) => `${name} * ${num}`)
                  .join(" , ");
              }
              var dataArr = {
                documentID: this.waybillNO,
                contents: [
                  {
                    templateURL: urls,
                    signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
                    data: {
                      orderNo: item.code, //订单号
                      logisticsNo: item.express_code, //运单号
                      shortAddress: item.pulling.mark, // 三段码
                      packageCenterName: item.packageCenterName, //
                      consignee: item.name, //收件人
                      consigneeTel: item.phone, //收件人联系方式
                      consigneeAddr: `${item.province_name} ${item.city_name} ${item.area_name} ${item.address}`, //收件人地址
                      consigner: from.username, //发件人
                      consignerTel: from.mobile, //发件人电话
                      consignerAddr: `${from.province} ${from.city} ${from.area} ${from.address}`, //发件人地址
                      goodsInfo: result,// `备注:${item.remark2}`, //物品名
                      note: item.remark2, //备注
                      logisticsMark: '', // 没用
                      twoDimensionCode: item.express_code, //二维码
                      now: item.add_time, //时间
                    },
                  },
                ],
              }
              arrs.push(dataArr)
            })
            var printData = this.SFgetPrintData(arrs)
            this.SFHdoPreviewLoading = true
            this.socket.send(JSON.stringify(printData))
          })
        }
      } else {
        this.$baseMessage('未选中任何行', 'warning')
        return false
      }
    },
    // 组装打印机需要的参数
    getPrintData() {
      var dataArr = []
      this.chooseItem.forEach((item, ind) => {
        if (item.pulling_type == 1) {
          dataArr.push({
            documentID: this.waybillNO,
            contents: [
              //电子面单部分
              {
                // templateURL: this.waybillTemplateURL + '?id=' + item.id,
                templateURL: `${this.waybillTemplateURL}?id=${item.id}&type=${this.mianDan_chiCun_num}`,
                signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
                //电子面单数据
              },
            ],
          })
        }
      })
      if (dataArr.length <= 0) {
        this.$message({
          type: 'warning',
          message: '没有可打印的圆通面单',
        })
        return
      }
      this.printTaskId = parseInt(1000 * Math.random())
      var request = {
        cmd: 'print',
        requestID: '12345678901234567890',
        version: '1.0',
        task: {
          taskID: '' + this.printTaskId,
          preview: false,
          printer: this.defaultPrinter,
          notifyMode: 'allInOne',
          previewType: 'pdf',
          documents: dataArr,
        },
      }
      return request
    },
    // 打印预览
    doPreview(type) {
      if (this.selectRows.length > 0) {
        if (type == 'YT') {
          var ids = []
          this.selectRows.forEach((item) => {
            if (item.pulling_type == 1) {
              ids.push(item.id)
            }
          })
          this.$baseConfirm('你确定打印预览选中项吗', null, async () => {
            var data = {
              id: ids,
              type: this.mianDan_chiCun_num,
            }
            Order_printCheck(data).then((res) => {
              var printData = this.getPrintData()
              printData.task.preview = true
              this.doPreviewLoading = true

              this.socket.send(JSON.stringify(printData))
            })
          })
        }
        if (type == 'SFK') {
          // 顺丰空运面单打印
          var ids = []
          this.selectRows.forEach((item) => {
            if (item.pulling_type == 3) {
              ids.push(item.id)
            }
          })
          var data = {
            id: ids,
          }
          var urls = ''
          if (this.mianDan_chiCun_num == 1) {
            // 150尺寸 顺丰空运面单
            console.log('150尺寸 顺丰海运面单')
            urls = 'https://cloudprint.cainiao.com/template/standard/877837'
          } else {
            // 180尺寸 顺丰空运面单
            console.log('180尺寸 顺丰海运面单')
            urls =
              'https://cloudprint.cainiao.com/template/standard/771230/16'
          }
          // 验证接口
          Order_printCheck(data).then((res) => {
            var arrs = []
            var from = {}
            from = res.data.from
            res.data.list.forEach((item, index) => {
              const goodsInfo = item.brand.map(item => `${item.brand_type_name} * ${item.num}`).join(',');
              var dataArr = {
                documentID: this.waybillNO,
                contents: [
                  {
                    // templateURL: 'https://cloudprint.cainiao.com/template/standard/771230/16',
                    templateURL: urls,
                    signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
                    data: {
                      orderNo: item.code, //订单号
                      logisticsNo: item.express_code, //运单号
                      shortAddress: item.pulling.mark, // 三段码
                      packageCenterName: item.packageCenterName, //
                      consignee: item.name, //收件人
                      consigneeTel: item.phone, //收件人联系方式
                      consigneeAddr: `${item.province_name} ${item.city_name} ${item.area_name} ${item.address}`, //收件人地址
                      consigner: from.username, //发件人
                      consignerTel: from.mobile, //发件人电话
                      consignerAddr: `${from.province} ${from.city} ${from.area} ${from.address}`, //发件人地址
                      goodsInfo: goodsInfo, //物品名
                      note: item.remark2, //备注
                      logisticsMark: '', // 没用
                      twoDimensionCode: item.pulling.two_dimension_code, //二维码
                      now: item.add_time, //时间
                    },
                  },
                ],
              }
              arrs.push(dataArr)
            })
            var printData = this.SFgetPrintData(arrs)
            printData.task.preview = true
            this.SFKdoPreviewLoading = true
            this.socket.send(JSON.stringify(printData))
          })
        }
        if (type == 'SFH') {
          // 顺丰海运面单打印
          var ids = []
          this.selectRows.forEach((item) => {
            // if (item.pulling_type == 4) {
            ids.push(item.id)
            // }
          })
          var data = {
            goods_order_id: ids,
          }
          var urls = ''
          if (this.mianDan_chiCun_num == 1) {
            // 150尺寸 顺丰海运面单
            console.log('预览 150尺寸 顺丰海运面单')
            urls = 'https://cloudprint.cainiao.com/template/standard/877264'
          } else {
            // 180尺寸 顺丰海运面单
            console.log('预览 180尺寸 顺丰海运面单')
            urls = 'https://cloudprint.cainiao.com/template/standard/765571'
          }

          // 验证接口
          print_detail(data).then((res) => {
            var arrs = []
            var from = {}
            from = res.data.from
            res.data.list.forEach((item, index) => {
              const goodsInfo = item.goods_order_spec.map(item => `${item.sku} * ${item.num}`).join(',');
              var dataArr = {
                documentID: this.waybillNO,
                contents: [
                  {
                    templateURL: urls,
                    signature: 'MD:kw4V6Gtj/7ZasLyotby+HA==',
                    data: {
                      orderNo: item.code, //订单号
                      logisticsNo: item.express_code, //运单号
                      shortAddress: item.pulling.mark, // 三段码
                      packageCenterName: item.packageCenterName, //
                      consignee: item.name, //收件人
                      consigneeTel: item.phone, //收件人联系方式
                      consigneeAddr: `${item.province_name} ${item.city_name} ${item.area_name} ${item.address}`, //收件人地址
                      consigner: from.username, //发件人
                      consignerTel: from.mobile, //发件人电话
                      consignerAddr: `${from.province} ${from.city} ${from.area} ${from.address}`, //发件人地址
                      goodsInfo: goodsInfo, //物品名`备注:${item.remark2}`, //备注 
                      note: item.remark2, //物品名
                      logisticsMark: '', // 没用
                      twoDimensionCode: item.pulling.two_dimension_code, //二维码
                      now: item.add_time, //时间
                    },
                  },
                ],
              }
              arrs.push(dataArr)
            })
            var printData = this.SFgetPrintData(arrs)
            printData.task.preview = true
            this.SFHdoPreviewLoading = true
            this.socket.send(JSON.stringify(printData))
          })
        }
      } else {
        this.$baseMessage('未选中任何行', 'warning')
        return false
      }
    },
    SFgetPrintData(arrs) {
      var dataArr = []
      if (arrs.length <= 0) {
        this.$message({
          type: 'warning',
          message: '没有可打印的顺丰面单',
        })
        return
      }
      this.printTaskId = parseInt(1000 * Math.random())
      var request = {
        cmd: 'print',
        requestID: '12345678901234567890',
        version: '1.0',
        task: {
          taskID: '' + this.printTaskId,
          preview: false,
          printer: this.defaultPrinter,
          notifyMode: 'allInOne',
          previewType: 'pdf',
          documents: arrs,
        },
      }
      return request
    },
    // 分页
    handleSizeChange(val) {
      this.queryForm.limit = val
      this.fetchData()
    },
    // 分页
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    // 查询
    handleQuery() {
      this.queryForm.page = 1
      this.fetchData()
    },
    // 请求数据
    async fetchData() {
      this.listLoading = true
      const {
        data
      } = await goodsOrderList(this.queryForm)
      this.list = data.list
      this.remindCount = data.statusCount
      this.total = data.count
      const imageList = []
      data.list.forEach((item, index) => {
        imageList.push(item.pic)
      })
      this.imageList = imageList
      setTimeout(() => {
        this.listLoading = false
      }, 500)
    },
  },
}
</script>

<style scoped>
:deep .el-button--mini {
  padding: 5px 11px;
}

:deep .right-panel {
  display: flex;
  align-items: center;
}

.demo-tabs .custom-tabs-label span {
  vertical-align: super;
  margin-left: 4px;
}

::v-deep(.el-badge__content.is-fixed) {
  top: 11px;
  right: 17px;
}

.table-container {
  padding: 15px 15px 0px 15px;
  box-sizing: border-box;
}

.el-tabs__item {
  width: 200px;
  /* 设置宽度为200px */
}

.el-badge {
  width: 60px !important;
}

::v-deep(.el-tabs__header) {
  margin: 0 !important;
}

::v-deep(.el-tabs__header span) {
  font-weight: bold;
}

.demo-table-expand {
  font-size: 0;
  padding-left: 150px;
  box-sizing: border-box;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 30%;
}

.dabaoStyle {
  background: #ffddaa;
  color: #999;
  border: 1px solid #fd5;
}

.fahuoStyle {
  background: #99dddd;
  color: #999;
  border: 1px solid 00FFFF;
}

.zhuanyunStyle {
  background: #ffffaa;
  color: #999;
  border: 1px solid FFFF00;
}

.sku_item {
  display: flex;
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 8px;
}

.sku_item:last-child {
  display: flex;
  border-bottom: 0px solid #f2f2f2;
}

.express_code_css {
  margin-bottom: 8px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>
